import React, { useState, lazy } from 'react';
import { Layout } from '../components/Layout';
import { Button } from '../components/Button';
import { ArrowRight, MapPin, Instagram, Quote } from 'lucide-react';
import { Link } from 'react-router-dom';
const CATEGORIES = [{
  name: 'Accessories',
  link: '/23m8/accessories.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/Category%20Images/Accessories2.JPG&opt=w3'
}, {
  name: 'Apparel',
  link: '/23m8/apparel.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/Category%20Images/apparel.JPG&opt=w3'
}, {
  name: 'Bathrooms',
  link: '/23m8/bathrooms.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/New_Temp/Bathrooms/Bathroom5.jpg&opt=w3'
}, {
  name: 'Bedrooms',
  link: '/23m8/bedrooms.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/New_Temp/Bedrooms/Bedrooms1.JPG&opt=w3'
}, {
  name: 'Before & After',
  link: '/23m8/before-after.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/New_Temp/Before%20%26%20After/140508121027.jpg&opt=w3'
}, {
  name: 'Commercial',
  link: '/23m8/commercial.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/P1013937.jpg&opt=w3'
}, {
  name: 'Dining Rooms',
  link: '/23m8/dining-rooms.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/P1014171.jpg&opt=w3'
}, {
  name: 'Furniture',
  link: '/23m8/furniture.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/New_Temp/Bedrooms/IMG_9817.JPG&opt=w3'
}, {
  name: 'Kitchens',
  link: '/23m8/kitchens.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/P1014168.jpg&opt=w3'
}, {
  name: 'Lighting',
  link: '/23m8/lighting.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/lighting%20and%20bathroom.jpg&opt=w3'
}, {
  name: 'Living Rooms',
  link: '/23m8/living-rooms.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/P1014111.jpg&opt=w3'
}, {
  name: 'Lower Levels',
  link: '/23m8/lower-levels.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/lower%20level.jpg&opt=w3'
}, {
  name: 'Seminars and Events',
  link: '/23m8/seminars-and-events.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/IMG_3233.jpg&opt=w3'
}, {
  name: 'Staging',
  link: '/23m8/staging.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/Blog%20Images/clutter%20free.jpg&opt=w3'
}, {
  name: 'Window Treatments',
  link: '/23m8/window-treatments.html',
  image: 'https://drwzpk38qkpfb.cloudfront.net/core/getthumb?site=10876&user=5982&w=204&h=215&mode=crop&file=uploaded/images/P1013895.jpg&opt=w3'
}];
export function Home() {
  const [activeVideo, setActiveVideo] = useState<'guided' | 'walkthrough'>('guided');
  return <Layout data-id="element-264">
      {/* Hero Section */}
      <section className="relative h-[85vh] min-h-[700px] flex items-center justify-center overflow-hidden" data-id="element-265">
        {/* Hero Background Placeholder */}
        <div className="absolute inset-0 bg-gradient-to-br from-taupe-200 to-cream-100" data-id="element-266">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiMyQzJDMkMiIGZpbGwtb3BhY2l0eT0iMC4wMiI+PHBhdGggZD0iTTM2IDE2YzAtMi4yMSAxLjc5LTQgNC00czQgMS43OSA0IDQtMS43OSA0LTQgNC00LTEuNzktNC00em0wIDI0YzAtMi4yMSAxLjc5LTQgNC00czQgMS43OSA0IDQtMS43OSA0LTQgNC00LTEuNzktNC00ek0xMiAxNmMwLTIuMjEgMS43OS00IDQtNHM0IDEuNzkgNCA0LTEuNzkgNC00IDQtNC0xLjc5LTQtNHptMCAyNGMwLTIuMjEgMS43OS00IDQtNHM0IDEuNzkgNCA0LTEuNzkgNC00IDQtNC0xLjc5LTQtNHoiLz48L2c+PC9nPjwvc3ZnPg==')] opacity-40" data-id="element-267"></div>
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-cream-100/80 via-transparent to-transparent" data-id="element-268" />

        <div className="relative z-20 text-center max-w-5xl px-4" data-id="element-269">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif text-charcoal-900 mb-6 leading-[1.1]" data-id="element-270">
            Timeless Interiors for
            <br data-id="element-271" />
            Michigan Homes
          </h1>
          <p className="text-xl md:text-2xl text-charcoal-800/80 mb-12 font-light max-w-3xl mx-auto leading-relaxed" data-id="element-272">
            Full-service interior design, curated home décor, and professional
            staging in Howell, Michigan—serving nearby Brighton and surrounding
            communities.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-273">
            <Link to="/portfolio" data-id="element-274">
              <Button size="lg" className="min-w-[200px]" data-id="element-275">
                View Portfolio
              </Button>
            </Link>
            <Link to="/store-info" data-id="element-276">
              <Button variant="outline" size="lg" className="min-w-[200px]" data-id="element-277">
                Visit the Store
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Intro/Brand Statement */}
      <section className="py-20 px-4 bg-white border-y border-taupe-200" data-id="element-278">
        <div className="max-w-4xl mx-auto text-center" data-id="element-279">
          <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-6 block" data-id="element-280">
            Welcome to Down Home Interiors
          </span>
          <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-8 leading-tight" data-id="element-281">
            Where Timeless Design Meets Personal Style
          </h2>
          <div className="prose prose-lg prose-stone mx-auto" data-id="element-282">
            <p className="text-lg text-charcoal-900/70 leading-relaxed mb-0" data-id="element-283">
              For over two decades, Down Home Interiors has been the trusted
              name in interior design throughout Howell and surrounding
              communities. We offer full-service interior decorating, a
              carefully curated retail collection of home décor and apparel, and
              professional real estate staging that helps homes sell faster and
              for more.
            </p>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="py-24 px-4 bg-cream-100" data-id="element-284">
        <div className="max-w-5xl mx-auto" data-id="element-285">
          <div className="text-center mb-12" data-id="element-286">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-287">
              Take a Tour
            </h2>
            <p className="text-charcoal-900/60" data-id="element-288">
              Experience our showroom from anywhere
            </p>
          </div>

          {/* Video Tabs */}
          <div className="flex justify-center gap-4 mb-8" data-id="element-289">
            <button onClick={() => setActiveVideo('guided')} className={`px-6 py-3 text-sm font-medium uppercase tracking-wide transition-all ${activeVideo === 'guided' ? 'text-charcoal-900 border-b-2 border-sage-500' : 'text-charcoal-900/50 hover:text-charcoal-900'}`} data-id="element-290">
              Guided Tour
            </button>
            <button onClick={() => setActiveVideo('walkthrough')} className={`px-6 py-3 text-sm font-medium uppercase tracking-wide transition-all ${activeVideo === 'walkthrough' ? 'text-charcoal-900 border-b-2 border-sage-500' : 'text-charcoal-900/50 hover:text-charcoal-900'}`} data-id="element-291">
              Walkthrough Tour
            </button>
          </div>

          {/* Video Container */}
          <div className="bg-white p-4 md:p-8 shadow-soft border border-taupe-200" data-id="element-292">
            <div className="aspect-video bg-taupe-200 flex items-center justify-center" data-id="element-293">
              {activeVideo === 'guided' ? <div className="text-center p-8" data-id="element-294">
                  <p className="text-charcoal-900/40 font-serif text-xl mb-2" data-id="element-295">
                    [PASTE VIMEO EMBED – Guided Tour]
                  </p>
                  <p className="text-charcoal-900/30 text-sm" data-id="element-296">
                    {/* Instructions: Replace this div with Vimeo iframe embed code */}
                    {/* Example: <iframe src="https://player.vimeo.com/video/YOUR_VIDEO_ID" ... */}
                    {/* Add loading="lazy" attribute to iframe */}
                  </p>
                </div> : <div className="text-center p-8" data-id="element-297">
                  <p className="text-charcoal-900/40 font-serif text-xl mb-2" data-id="element-298">
                    [PASTE VIMEO EMBED – Walkthrough Tour]
                  </p>
                  <p className="text-charcoal-900/30 text-sm" data-id="element-299">
                    {/* Instructions: Replace this div with Vimeo iframe embed code */}
                    {/* Example: <iframe src="https://player.vimeo.com/video/YOUR_VIDEO_ID" ... */}
                    {/* Add loading="lazy" attribute to iframe */}
                  </p>
                </div>}
            </div>
          </div>
        </div>
      </section>

      {/* Portfolio/Services Category Grid */}
      <section className="py-24 px-4 bg-white" data-id="element-300">
        <div className="max-w-7xl mx-auto" data-id="element-301">
          <div className="text-center mb-16" data-id="element-302">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-303">
              Explore Our Work
            </h2>
            <p className="text-lg text-charcoal-900/60" data-id="element-304">
              From complete renovations to curated décor, discover our portfolio
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-id="element-305">
            {CATEGORIES.map(category => <a key={category.name} href={category.link} className="group relative aspect-[3/4] bg-taupe-200 overflow-hidden border border-taupe-300 hover:shadow-soft transition-all duration-300" data-id="element-306">
                {/* Category Image */}
                <img src={category.image} alt={category.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-307" />

                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-charcoal-900/80 via-charcoal-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-308" />

                {/* Category Name */}
                <div className="absolute bottom-0 left-0 right-0 p-4 text-center transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300" data-id="element-309">
                  <h3 className="text-white font-serif text-lg group-hover:text-sage-200 transition-colors" data-id="element-310">
                    {category.name}
                  </h3>
                </div>
              </a>)}
          </div>
        </div>
      </section>

      {/* About Preview Section */}
      <section className="py-24 px-4 bg-taupe-200/30" data-id="element-311">
        <div className="max-w-6xl mx-auto" data-id="element-312">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-313">
            <div className="aspect-[4/5] bg-taupe-300 flex items-center justify-center text-charcoal-900/20 font-serif text-xl" data-id="element-314">
              [Owner/Team Photo]
            </div>
            <div data-id="element-315">
              <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-4 block" data-id="element-316">
                Our Story
              </span>
              <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-317">
                Passion Meets Experience
              </h2>
              <p className="text-lg text-charcoal-900/70 leading-relaxed mb-6" data-id="element-318">
                For over 20 years, Down Home Interiors has been transforming
                spaces throughout Howell and beyond. Our founder brings a
                passion for timeless design and a commitment to personalized
                service that makes every project unique.
              </p>
              <p className="text-lg text-charcoal-900/70 leading-relaxed mb-8" data-id="element-319">
                We believe great design is about understanding how you live,
                what you love, and creating spaces that feel authentically
                yours. From initial consultation to final installation, we're
                with you every step of the way.
              </p>
              <Link to="/about" data-id="element-320">
                <Button variant="outline" className="group" data-id="element-321">
                  Read More About Us
                  <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" data-id="element-322" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Retail Store Highlight */}
      <section className="py-24 px-4 bg-white" data-id="element-323">
        <div className="max-w-6xl mx-auto" data-id="element-324">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-325">
            <div className="lg:order-2 aspect-[4/3] bg-taupe-300 flex items-center justify-center text-charcoal-900/20 font-serif text-xl" data-id="element-326">
              [Showroom Photo]
            </div>
            <div className="lg:order-1" data-id="element-327">
              <span className="text-sage-600 uppercase tracking-[0.2em] text-xs font-semibold mb-4 block" data-id="element-328">
                Visit Our Showroom
              </span>
              <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-6" data-id="element-329">
                Experience Design in Person
              </h2>
              <p className="text-lg text-charcoal-900/70 leading-relaxed mb-6" data-id="element-330">
                Step into our beautifully curated showroom where you'll find an
                ever-changing collection of home décor, furniture, apparel, and
                accessories. Our knowledgeable team is always available to offer
                design advice and help you find exactly what you're looking for.
              </p>

              <div className="bg-cream-50 p-6 border border-taupe-200 mb-8" data-id="element-331">
                <div className="flex items-start mb-4" data-id="element-332">
                  <MapPin className="text-sage-500 mr-3 mt-1 flex-shrink-0" size={20} data-id="element-333" />
                  <address className="not-italic text-charcoal-900" data-id="element-334">
                    <strong className="block mb-1" data-id="element-335">Down Home Interiors</strong>
                    2729 E. Grand River Ave.
                    <br data-id="element-336" />
                    Howell, MI 48843
                  </address>
                </div>
                <p className="text-sm text-charcoal-900/60 ml-8" data-id="element-337">
                  Open Monday–Saturday
                </p>
              </div>

              <a href="https://www.google.com/maps/search/?api=1&query=2729+E.+Grand+River+Ave.+Howell+MI+48843" target="_blank" rel="noopener noreferrer" data-id="element-338">
                <Button data-id="element-339">Get Directions</Button>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Preview */}
      <section className="py-24 px-4 bg-cream-100" data-id="element-340">
        <div className="max-w-6xl mx-auto" data-id="element-341">
          <div className="text-center mb-16" data-id="element-342">
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-343">
              What Our Clients Say
            </h2>
            <p className="text-lg text-charcoal-900/60" data-id="element-344">
              Trusted by homeowners throughout Michigan
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-345">
            {[{
            quote: 'Working with Down Home Interiors transformed our house into a home. Their attention to detail and understanding of our style was remarkable.',
            author: 'Sarah M.',
            location: 'Brighton'
          }, {
            quote: 'The staging services helped us sell our home in record time. Professional, creative, and worth every penny.',
            author: 'Michael & Jennifer T.',
            location: 'Howell'
          }, {
            quote: 'From consultation to installation, the team made the entire process seamless. Our living room has never looked better.',
            author: 'Patricia L.',
            location: 'Hartland'
          }].map((testimonial, index) => <div key={index} className="bg-white p-8 shadow-card border border-taupe-200 relative" data-id="element-346">
                <Quote className="absolute top-6 left-6 text-sage-200 h-8 w-8" data-id="element-347" />
                <div className="relative z-10 pt-8" data-id="element-348">
                  <p className="text-charcoal-900/70 italic mb-6 leading-relaxed" data-id="element-349">
                    "{testimonial.quote}"
                  </p>
                  <div data-id="element-350">
                    <p className="font-serif font-medium text-charcoal-900" data-id="element-351">
                      {testimonial.author}
                    </p>
                    <p className="text-xs text-charcoal-900/50 uppercase tracking-wide" data-id="element-352">
                      {testimonial.location}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>

          <div className="text-center" data-id="element-353">
            <Link to="/testimonials" data-id="element-354">
              <Button variant="outline" data-id="element-355">View All Testimonials</Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Instagram Section */}
      <section className="py-24 px-4 bg-white border-y border-taupe-200" data-id="element-356">
        <div className="max-w-6xl mx-auto" data-id="element-357">
          <div className="text-center mb-12" data-id="element-358">
            <Instagram className="h-12 w-12 text-sage-500 mx-auto mb-6" data-id="element-359" />
            <h2 className="text-3xl md:text-4xl font-serif text-charcoal-900 mb-4" data-id="element-360">
              Follow Our Journey
            </h2>
            <p className="text-lg text-charcoal-900/60 mb-8" data-id="element-361">
              See our latest projects and design inspiration on Instagram
            </p>
          </div>

          {/* Instagram Feed Placeholder */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-8" data-id="element-362">
            {[1, 2, 3, 4, 5, 6].map(item => <div key={item} className="aspect-square bg-taupe-200 flex items-center justify-center text-charcoal-900/20 text-xs" data-id="element-363">
                [IG Post {item}]
              </div>)}
          </div>

          <div className="text-center" data-id="element-364">
            <a href="https://www.instagram.com/downhomeinteriors/" target="_blank" rel="noopener noreferrer" data-id="element-365">
              <Button variant="outline" data-id="element-366">
                <Instagram className="mr-2 h-4 w-4" data-id="element-367" />
                Follow @downhomeinteriors
              </Button>
            </a>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section className="py-24 px-4 bg-gradient-to-br from-taupe-200/50 to-cream-100" data-id="element-368">
        <div className="max-w-4xl mx-auto text-center" data-id="element-369">
          <h2 className="text-4xl md:text-5xl font-serif text-charcoal-900 mb-6 leading-tight" data-id="element-370">
            Ready to Transform Your Space?
          </h2>
          <p className="text-xl text-charcoal-900/70 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-371">
            Schedule a consultation and discover how we can bring your vision to
            life with personalized design solutions.
          </p>
          <Link to="/contact" data-id="element-372">
            <Button size="lg" className="min-w-[200px]" data-id="element-373">
              Contact Us
            </Button>
          </Link>
        </div>
      </section>
    </Layout>;
}